import React from "react";
import Content from "../../../../../../layout/content/Content";
import GalleryImage from "../../../../../../components/partials/gallery/GalleryImage";
import countryList from "react-select-country-list";

const PepHioTab = ({ data }) => {
  return (
    <React.Fragment>
      {data && (
        <Content>
          <div className="nk-block-head">
            <h5 className="title">POE/HIO Status</h5>
          </div>
          <div className="card card-bordered card-stretch">
            <div className="card-inner-group">
              <div className="card-inner p-0">
                <div className="nk-tb-list nk-tb-ulist">
                  <div className="profile-ud wider">
                    <span
                      style={{
                        fontSize: "14px",
                        margin: "0px 0px 0px 20px",
                        width: "50%",
                      }}
                      className="profile-ud-label"
                    >
                      Is PEP/HIO?
                    </span>

                    <span
                      style={{
                        textAlign: "left",
                        fontSize: "14px",
                        margin: "0px 20px 0px 0px",
                        width: "50%",
                      }}
                      id="title"
                      className="profile-ud-value"
                    >
                      {data.pep_hio && data.financial.involve_money ? data.pep_hio.is_pep_hio === 'y' ? 'Yes' : "No" : 'Not Collected'}
                    </span>
                  </div>
                  {data.pep_hio && data.pep_hio.is_pep_hio === 'y' &&
                    <>

                      <hr style={{ margin: "0" }} />
                      <div className="profile-ud wider">
                        <span
                          style={{
                            fontSize: "14px",
                            margin: "0px 0px 0px 20px",
                            width: "50%",
                          }}
                          className="profile-ud-label"
                        >
                          Position(s):
                        </span>

                        <span
                          style={{
                            textAlign: "left",
                            fontSize: "14px",
                            margin: "0px 20px 0px 0px",
                            width: "50%",
                          }}
                          id="name"
                          className="profile-ud-value"
                        >
                          {data.pep_hio.position_pep_hio}
                        </span>
                      </div>
                      <hr style={{ margin: "0" }} />
                      <div className="profile-ud wider">
                        <span
                          style={{
                            fontSize: "14px",
                            margin: "0px 0px 0px 20px",
                            width: "50%",
                          }}
                          className="profile-ud-label"
                        >
                          Position's Country
                        </span>
                        <span
                          style={{
                            textAlign: "left",
                            fontSize: "14px",
                            margin: "0px 20px 0px 0px",
                            width: "50%",
                          }}
                          id="activity"
                          className="profile-ud-value"
                        >
                          {countryList().getLabel(data.pep_hio.position_country_pep_hio)}
                        </span>

                      </div>

                    </>}
                </div>
              </div>
            </div>
          </div>
          {data.pep_hio && data.pep_hio.is_pep_hio === 'y' && data.pep_hio.is_pep_hio_family === 'y' && (
            <>
              <div className="nk-block-head">
                <h5 className="title">Family Member or Associate of a PEP/HIO</h5>
              </div>
              <div className="card card-bordered card-stretch mb-3">
                <div className="profile-ud wider">
                  <span
                    style={{
                      fontSize: "14px",
                      margin: "0px 0px 0px 20px",
                      width: "50%",
                    }}
                    className="profile-ud-label"
                  >
                    Is Family Of PEP/HIO?
                  </span>

                  <span
                    style={{
                      textAlign: "left",
                      fontSize: "14px",
                      margin: "0px 20px 0px 0px",
                      width: "50%",
                    }}
                    id="title"
                    className="profile-ud-value"
                  >
                    {data.pep_hio && data.pep_hio.is_pep_hio === 'y' ? 'Yes' : "No"}
                  </span>
                </div>
              </div>
              <div className="card card-bordered card-stretch">
                <div className="card-inner-group">
                  <div className="card-inner p-0">
                    <div className="nk-tb-list nk-tb-ulist">
                      <div className="profile-ud wider">
                        <span
                          style={{
                            fontSize: "14px",
                            margin: "0px 0px 0px 20px",
                            width: "2%",
                          }}
                        >
                          #
                        </span>
                        <span
                          style={{
                            fontSize: "14px",
                            margin: "0px 0px 0px 20px",
                            width: "24%",
                          }}
                        >
                          Name
                        </span>
                        <span
                          style={{
                            fontSize: "14px",
                            width: "24%",
                          }}
                        >
                          position
                        </span>
                        <span
                          style={{
                            fontSize: "14px",
                            width: "24%",
                          }}
                        >
                          Position's Country
                        </span>

                        <span
                          style={{
                            fontSize: "14px",
                            width: "24%",
                          }}
                        >
                          relationship
                        </span>
                      </div>
                      <hr style={{ margin: "0" }} />
                      {data.pep_hio_family &&
                        data.pep_hio_family.map((person, index) => {
                          return (
                            <React.Fragment key={index}>
                              {" "}
                              <div className="profile-ud wider">
                                <span
                                  style={{
                                    textAlign: "left",
                                    fontSize: "14px",
                                    margin: "0px 0px 0px 20px",
                                    width: "2%",
                                    color: "#526484",
                                    fontWeight: "500",
                                  }}
                                  id="number"
                                >
                                  {index + 1}
                                </span>
                                <span
                                  style={{
                                    textAlign: "left",
                                    fontSize: "14px",
                                    margin: "0px 0px 0px 20px",
                                    width: "24%",
                                    color: "#526484",
                                    fontWeight: "500",
                                  }}
                                  id="name"
                                >
                                  {person.name}
                                </span>
                                <span
                                  style={{
                                    textAlign: "left",
                                    fontSize: "14px",
                                    width: "24%",
                                    color: "#526484",
                                    fontWeight: "500",
                                  }}
                                  id="title"
                                >
                                  {person.position}
                                </span>
                                <span
                                  style={{
                                    textAlign: "left",
                                    fontSize: "14px",
                                    width: "24%",
                                    color: "#526484",
                                    fontWeight: "500",
                                  }}
                                  id="email"
                                >
                                  {countryList().getLabel(person.position_country)}
                                  {person.email}
                                </span>
                                <span
                                  style={{
                                    textAlign: "left",
                                    fontSize: "14px",
                                    width: "24%",
                                    color: "#526484",
                                    fontWeight: "500",
                                  }}
                                  id="signing-binding-authority"
                                >
                                  {person.relationship}

                                </span>


                              </div>
                              <hr style={{ margin: "0" }} />
                            </React.Fragment>
                          );
                        })}
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </Content>
      )}
    </React.Fragment>
  );
};

export default PepHioTab;
